// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"5c75846f","235":"5324f555","289":"f5b88aa9","330":"6b18960d","471":"330959cd","730":"90bee824"}[chunkId] + ".chunk.js";
};